import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { useContact } from "../context/ContentContext";

// Floating contact buttons (call + WhatsApp) shown on every page
export default function WhatsAppFloat() {
  const CONTACT = useContact();
  const waHref = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
    "Hi EMB, I'd like a quote for some building work."
  )}`;
  const telHref = `tel:${CONTACT.phone.replace(/\s+/g, "")}`;

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-3">
      <a
        href={telHref}
        aria-label="Call Efficient Master Builders"
        data-testid="floating-call-button"
        className="group flex items-center gap-3"
      >
        <span className="hidden md:inline-block bg-homi-black text-white text-sm font-heading font-semibold px-4 py-2 rounded-full shadow-lg opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
          Call us
        </span>
        <span className="relative w-14 h-14 rounded-full bg-homi-gold flex items-center justify-center shadow-xl transition-transform group-hover:scale-110">
          <Phone className="w-6 h-6 text-homi-black relative" />
        </span>
      </a>

      <a
        href={waHref}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with us on WhatsApp"
        data-testid="floating-whatsapp-button"
        className="group flex items-center gap-3"
      >
        <span className="hidden md:inline-block bg-homi-black text-white text-sm font-heading font-semibold px-4 py-2 rounded-full shadow-lg opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
          Chat with us
        </span>
        <span className="relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-xl transition-transform group-hover:scale-110">
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
          <MessageCircle className="w-7 h-7 text-white fill-white relative" />
        </span>
      </a>
    </div>
  );
}
